import { useCallback } from 'react';

import PropTypes from 'prop-types';

import { Mediator } from '@spotahome/soyuz-mediator';

import Tooltip from '../Tooltip';

import { DSIcon } from '../../../base';

import { OPEN_INFORMATION_MODAL } from '../utils/constants';
import { useMediaQuery } from '../utils/breakpoints/breakpoints';

import styles from './InfoTooltip.module.scss';

const InfoTooltip = ({ className = '', tooltipText, title }) => {
  const { isBiggerThanPhablet } = useMediaQuery();

  const openMobileModal = useCallback(() => {
    Mediator.publish(OPEN_INFORMATION_MODAL, {
      title,
      body: (
        <div className={styles['info-tooltip__modal-body']}>{tooltipText}</div>
      )
    });
  }, [title, tooltipText]);

  if (isBiggerThanPhablet()) {
    return (
      <Tooltip
        className={className}
        color="blue-indigo"
        position="bottom"
        tooltip={tooltipText}
        isRebranded
        size={Tooltip.SIZE_BIG}
      >
        <DSIcon name="info" className={styles['info-tooltip__icon']} />
      </Tooltip>
    );
  }

  return (
    <button
      type="button"
      className={`${className} ${styles['info-tooltip__trigger']}`.trim()}
      onClick={openMobileModal}
      aria-label={title}
    >
      <DSIcon name="info" className={styles['info-tooltip__icon']} />
    </button>
  );
};

InfoTooltip.propTypes = {
  className: PropTypes.string,
  tooltipText: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired
};

export default InfoTooltip;
